import { BiSearchAlt2 } from "react-icons/bi";
import { FILTER } from "../../../../services/constants/user/main";
import { ChangeEvent, useRef } from "react";
import SemiSquareButton from "../../commons/SemiSquareButton";

const InvoiceFilter = ({
  changeHandle,
}: {
  changeHandle: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}) => {
  const selectRef = useRef<HTMLSelectElement | null>(null);

  return (
    <section className="mt-[20px] pb-[20px] border-secondary-light">
      <div className="flex h-[30px] gap-[8px] relative">
        <div className="relative">
          <input
            type="text"
            name="query"
            id=""
            className="h-full max-w-[200px] pl-[12px] pr-[35px] placeholder-[#BEBEBE] text-[11px] leading-[100%] border-[#E1E3E2] rounded-[5px]"
            placeholder="キーワードを入れて検索"
            onChange={changeHandle}
          />
          <BiSearchAlt2
            className="absolute top-[5px] right-[9.26px] text-secondary-light"
            size={22}
          />
        </div>
        <div className="relative">
          <select
            name="limit"
            id=""
            className="h-full pr-[33px] pl-[7px] appearance-none text-secondary-dark text-[11px] leading-[100%] w-[90px]"
            onChange={changeHandle}
            ref={selectRef}
          >
            {FILTER.OPTION.RECORD_LIMIT.map((item, index) => (
              <option value={item.value} className="" key={index}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
};

export default InvoiceFilter;
